import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
  HostListener,
} from '@angular/core';

export interface ButtonMenuItem {
  label: string;
  labelProcessing?: string;
  icon?: string;
  action: string;
  disabled?: boolean;
  tooltip?: string;
}

@Component({
  selector: 'app-button-multi-select',
  templateUrl: './button-multi-select.component.html',
  styleUrls: ['./button-multi-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ButtonMultiSelectComponent implements OnChanges {
  @Input() menuItems: ButtonMenuItem[] = [];
  @Input() selectedMenuItem: ButtonMenuItem;
  @Input() tooltip: string = '';
  @Input() isProcessing: boolean;
  @Input() disabledSelection: boolean;
  @Input() disabled: boolean;
  @Input() minWidth = '120px';
  @Input() label: string;
  @Output() buttonClick = new EventEmitter<string>();
  @Output() menuItemClick = new EventEmitter<ButtonMenuItem>();

  showMenu = false;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    const selChange = changes['selectedMenuItem'];
    if (selChange?.currentValue != null) {
      return;
    }
    if (
      changes['menuItems']?.currentValue?.length > 0 &&
      !this.selectedMenuItem
    ) {
      this.selectedMenuItem = this.menuItems[0];
    }
  }

  onButtonClick($event: Event) {
    if (this.disabled) return;
    $event.preventDefault();
    this.buttonClick.emit(this.selectedMenuItem?.action);
  }

  onMenuItemSelect(item: ButtonMenuItem) {
    if (!item?.action || this.disabledSelection) return;
    this.menuItemClick.emit(item);
    this.showMenu = false;
  }

  toggleMenu($event: Event) {
    if (this.disabledSelection) return;
    $event.preventDefault();
    this.showMenu = !this.showMenu;
  }

  get tooltipContent(): string | null {
    const content = this.tooltip || this.selectedMenuItem?.tooltip;
    return content && content.trim() ? content : null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.app-button-multi-select')) {
      this.showMenu = false;
    }
  }
}
